import { makeAutoObservable } from 'mobx';
import { SUBSCRIPTION_MODAL_KEY } from '../../systems/ModalSystem';

export default class UpgradeButtonPresenter {
	constructor( { workspaces, modalSystem, history } ) {
		this.workspaces = workspaces;
		this.modalSystem = modalSystem;
		this._history = history;

		this.subscriptionModalIsOpen = false;
		makeAutoObservable( this );
	}

	openSubscriptionModal = () => {
		if ( this._currentUserWorkspace?.subscription?.inPlanTrial ) {
			this._history.push( `/user/workspaces/${this._currentUserWorkspace.id}/plan` );
			return;
		}
		this.modalSystem.showModal( { modalKey: SUBSCRIPTION_MODAL_KEY } );
	};

	get freeTrialPlanName() {
		if ( !this._currentUserWorkspace?.subscriptionPlanName ) return '';

		return `${this._currentUserWorkspace.subscriptionPlanName.replace( ' Plan', '' )} Trial`;
	}

	get daysLeft() {
		return this._currentUserWorkspace?.daysLeftOnFreeTrial;
	}

	get showUpgradeButton() {
		return !!this._currentUserWorkspace && !this.currentUserIsOnActivePaidWorkspace;
	}

	get currentUserIsOnActivePaidWorkspace() {
		return this.workspaces?.some( workspace => workspace.hasAPaidPlan && workspace.isActive )
	}

	get showWarningIcon() {
		return this.daysLeft <= 7;
	}

	get isOnExpiredFreeTrial() {
		return this._currentUserWorkspace?.isOnExpiredFreeTrial;
	}

	get buttonText() {
		return this._currentUserWorkspace?.subscription?.inPlanTrial ? 'See Plan Details' : 'Buy Now';
	}

	get _currentUserWorkspace() {
		return this.workspaces?.find( workspace => workspace.currentUserIsOwner );
	}
}
